import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { BreadCrumbModel } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import {
  GridOptionsModel, ColumnDefinitionsModel, PaginationsModel,
  FetchCriteriaModel
} from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { UserWizardModel } from 'lib/ng2-sapmp/src/models';
import { BulkWizardDataService } from './../bulk-wizard-data-service';
import { ANALYTICS_CONSTANTS } from 'config';
import { UserWizardService } from 'lib/ng2-sapmp/src/providers';
declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html

@Component({
  selector: 'app-bulk-users-confirm',
  templateUrl: './bulk-confirm.component.html',
  styleUrls: ['./../bulk-users.component.scss'],
  providers: [BulkWizardDataService],
})

export class BulkConfirmComponent implements OnInit {
  reviewData: any;
  breadCrumbs: BreadCrumbModel[];
  totalRecords: number;
  status: string;
  gridOptions: GridOptionsModel;

  errorColumns: Array<ColumnDefinitionsModel> = [
    { field: 'displayName', caption: 'User', type: 'TEXT' },
    { field: 'email', caption: 'Email', type: 'TEXT' },
    { field: 'phoneNumber', caption: 'Contact number', type: 'TEXT' },
    { field: 'errorMessage', caption: 'Message', type: 'TEXT' }
  ];

  paginations: PaginationsModel = {
    recordsPerPage: 20,
    currentPage: 1,
    totalRecords: 0,
    isServerSide: false
  };

  constructor(private stepindicatorService: StepIndicatorService,
    private breadCrumbService: BreadCrumbService,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router, private bulkWizardDataService: BulkWizardDataService,
    private utilityService: UtilityService,
    private userWizardService: UserWizardService
  ) {
  }

  ngOnInit() {
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    if (sessionStorage.getItem('review-status') === null) {
      this.router.navigate(['/home']);
    } else {
      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
      this.reviewData = JSON.parse(sessionStorage.getItem('review-status'));
      this.processData(this.reviewData);
    }
    this.bulkWizardDataService.createPageLoadProperties(this.router.routerState.snapshot.url,
      'Bulk User upload - Confirm',
      ANALYTICS_CONSTANTS.FRIENDLY_NAME_BULKUPLOAD_STEP4);
  }
  processData(data) {

    this.status = data.status;
    if (data.status === 'completed') {
      this.totalRecords = data.processedRecords;
    } else if (data.status === 'error') {
      data.items.forEach(function (dt) { dt.displayName = dt.firstName + ' ' + dt.lastName; });
      this.totalRecords = data.processedRecords - data.totalUsers;
      this.gridOptions = new GridOptionsModel();
      this.gridOptions.columnDefinitions = this.errorColumns;
      this.gridOptions.enableFiltering = false;
      this.paginations.totalRecords = data.totalUsers;
      this.gridOptions.Paginations = this.paginations;
      this.gridOptions.enableSorting = true;
      this.gridOptions.gridData = data.items;
      this.utilityService.loadFocusOnTop();
    }
  }

  gotoPage(pageUrl) {
    sessionStorage.removeItem('steps-bulkUsers');
    this.router.navigate([pageUrl]);
  }

  assignUnassignWizard() {
    this.breadCrumbService.removeLastBreadCrumb();
    sessionStorage.removeItem('steps-bulkUsers');
    const userWizardModel = new UserWizardModel();
    userWizardModel.previousUrl = '/bulkUsers';
    this.userWizardService.addAssignOrUnassignWizard(userWizardModel);
    this.router.navigate(['/manageUsers']);
  }
}
